import React from 'react';
import { filterMatchesByTimestamp } from '../../data/utils/filterMatchesByTimestamp';
import MatchLink from '../navigation/MatchLink';
import { PrematchContext } from '../Prematch';

export default function PrematchMatchDropdown(props) {
    const prematchContext = React.useContext(PrematchContext);

    let matches = filterMatchesByTimestamp(props.tournament.events, prematchContext.temporalFilter.type);
    if (props.tournament.liveMatches) {
        matches = [...props.tournament.liveMatches, ...matches];
    }

    return (
        <>
            <div id="popup-events" className="popup">
                <div className="popup-content centered">
                    <div className="manif-heading text-small">{props.tournament.descrizione}</div>
                    {matches.map(match => {
                        function handleClick() {
                            props.toggleDropdown();
                            prematchContext.openMatch(match);
                        }
                        const selected = match.id === prematchContext.match.id;
                        return (
                            /* <div key={match.uniqueId} className={"event-desc text-small" + classIf(selected, 'selected')} onClick={handleClick}>
                                {match.team2 ?
                                    <div className="d-flex flex-column align-items-start">
                                        <span>{match.team1}</span>
                                        <span>{match.team2}</span>
                                    </div>
                                    :
                                    <span>{match.team1}</span>
                                }
                                <span className="push-right">{match.date}</span>
                            </div> */
                            <MatchLink key={match.uniqueId} {...match} selected={selected} openMatch={handleClick} />
                        );
                    })}
                </div>
            </div>
        </>
    );
}
